/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateJiraVerificationKeyInput = {|
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type createJiraVerificationKeyMutationVariables = {|
  input: CreateJiraVerificationKeyInput
|};
export type createJiraVerificationKeyMutationResponse = {|
  +createJiraVerificationKey: ?{|
    +company: ?{|
      +jiraVerificationKey: ?string
    |}
  |}
|};
export type createJiraVerificationKeyMutation = {|
  variables: createJiraVerificationKeyMutationVariables,
  response: createJiraVerificationKeyMutationResponse,
|};
*/


/*
mutation createJiraVerificationKeyMutation(
  $input: CreateJiraVerificationKeyInput!
) {
  createJiraVerificationKey(input: $input) {
    company {
      jiraVerificationKey
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateJiraVerificationKeyInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraVerificationKey",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createJiraVerificationKeyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateJiraVerificationKeyPayload",
        "kind": "LinkedField",
        "name": "createJiraVerificationKey",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createJiraVerificationKeyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateJiraVerificationKeyPayload",
        "kind": "LinkedField",
        "name": "createJiraVerificationKey",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createJiraVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createJiraVerificationKeyMutation(\n  $input: CreateJiraVerificationKeyInput!\n) {\n  createJiraVerificationKey(input: $input) {\n    company {\n      jiraVerificationKey\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3a0ccbea5711e11af3cd06f1a6804fda';

module.exports = node;
